<template>
	<ui-dialog :title="title" @submit="onSubmit" @close="onClose" defaultSlotContainerClassNames="CustomerTree__container" class="customer-move-dialog">
		<template #nonWrappedBody>
			<div class="px-4 pt-4" v-if="$isAllowedTo('tree_move_level_globally')">
				<CompanyDropdown @on-select="onSelectCompany" is-move :value="selectedCompany" />
			</div>
		</template>
		<div class="field search">
			<div class="control">
				<input
					type="text"
					class="input"
					:placeholder="$t('customer_selection.search_customer')"
					v-model="searchValue"
					@keyup.esc="clearSearch"
				/>
			</div>
		</div>
		<CustomerTree :items="customerList" is-move @on-select="onSelectCustomer" :selected-id="selectedCustomer?.id" :disabled-ids="[disabledCustomerId]"/>

		<template #actions>
			<div class="is-flex is-justify-content-space-between">
				<div class="is-flex is-align-items-center">
					<ui-alert v-if="error" error>{{ error }}</ui-alert>
					<ui-alert v-if="successMessage" success>{{ successMessage }}</ui-alert>
				</div>
				<ui-btn class="is-info" :loading="isPending" type="submit" icon="fa-save" :disabled="customers.length < 1">{{ $t('customer_selection.select') }}</ui-btn>
			</div>
		</template>
	</ui-dialog>
</template>

<script>
import CompanyDropdown from '@/components/company/company-dropdown';
import CustomerTree from '@/components/customer/customer-tree';

import { mapGetters, mapActions } from 'vuex';

export default {
	components: {
		CompanyDropdown,
		CustomerTree
	},

	props: {
		title: String,
		disabledCustomerId: String
	},

	data: () => ({
		selectedCompany: null,
		selectedCustomer: null,
		customers: [],
		searchValue: '',

		error: '',
		successMessage: '',
		isPending: false
	}),

	computed: {
		...mapGetters('user', ['getUser', 'getActiveCustomer', 'getActiveCompany']),

		customerList() {
			if (!this.customers.length) return [];
			
			let list = this.customers.filter(customer => customer.name.toLowerCase().includes(this.searchValue.toLowerCase()));
			
			return list;
		}
	},

	created() {
		this.selectedCompany = {...this.getActiveCompany};
		this.fetchTree();
	},

	methods: {
		...mapActions('user', ['setActiveCustomer']),

		onSelectCompany(company) {
			this.selectedCompany = company;
			this.fetchTree();
		},

		onSelectCustomer(customer) {
			this.selectedCustomer = customer;
		},

		onSubmit() {
			this.error = '';
			this.successMessage = '';

			const targetCustomerObj = this.$utils.tree.findById(this.customers, this.selectedCustomer.id);

			const targetIsChild = this.fromCustomer?.id ? this.$utils.tree.toFlat([targetCustomerObj]).some(x => x.id === this.fromCustomer.id) : false;

			if (targetIsChild) {
				this.error = this.$t('customer_selection.error_cannot_move_under_self');

				return;
			}
			
			this.$emit('selectCustomer', this.selectedCustomer);
		},

		async fetchTree() {
			this.error = '';
			let rootNode = null;

			if (!this.$isAllowedTo('tree_modify_level')) return;

			if (!this.$isAllowedTo('tree_move_level_within_root')) {
				rootNode = this.getUser.customer;
			} else if (!this.$isAllowedTo('tree_move_level_within_company'))
				rootNode = await this.$services.customer.getRootCustomer({
					customerId: this.getActiveCustomer.id,
					companyId: this.getActiveCompany.id
				}, {
					loading: val => {
						this.isPending = val;
					}
				});

			try {
				this.customers = await this.$services.customer.getTree({
					companyNode: this.selectedCompany.id,
					parentNode: rootNode ? rootNode.id : null
				}, {
					loading: val => {
						this.isPending = val;
					}
				});
			} catch (error) {
				this.error = error.message;
			}
		},
		
		clearSearch() {
			this.searchValue = '';
		},

		onClose() {
			this.$emit('close');
		}
	}
};
</script>

<style lang="scss" scoped>
.customer-move-dialog {
	overflow: visible;

	.modal-card {
		overflow: visible;
		.ui-card {
			height: 100%;

			.ui-form {
				display: flex;
				flex-direction: column;
				height: 100%;
				overflow: visible;

				.CustomerTree__container {
					padding-top: 0;
					overflow: hidden;

					> .CustomerTree {
						height: 100%;
						overflow-y: scroll;
					}
				}

				.ui-card-actions {
					margin-top: 1rem;
				}
			}
		}

	}
}

.search.field {
	padding-right: 16px;
	.input {
		max-height: 2rem;
		padding: 0.5rem;
		border-radius: 4px;
	}
}
</style>
